<template>
	<v-menu
		v-if="user"
		bottom
		min-width="250px"
		rounded
		max-width="400px"
		offset-y
		class="ml-auto"
	>
		<template v-slot:activator="{ on }">
			<v-btn v-on="on" text elevation="0" plain>
				<div class="d-flex">
					<avatar hide-activity />
				</div>
				<div v-if="username" class="user-name d-none d-lg-block ml-3">
					{{ username }}
					<div class="subtitle">
						{{ user.brand }}
					</div>
				</div>

				<v-icon>mdi-chevron-down</v-icon>
			</v-btn>
		</template>

		<v-card>
			<v-list-item-content class="justify-center">
				<div class="mx-auto text-center">
					<avatar hide-activity />
					<h3 class="mt-2">{{ user.name }}</h3>
					<p class="text-caption mt-1">
						{{ user.email }}
					</p>
					<v-divider class="my-3"></v-divider>
					<v-btn depressed rounded text :to="{ name: 'Settings' }">
						Ustawienia konta
					</v-btn>

					<v-divider class="my-3"></v-divider>
					<v-btn
						depressed
						rounded
						text
						:to="{
							name: 'Profile',
							params: {
								userID: this.$store.state.auth.user.id,
							},
						}"
					>
						Wyświetl profil
					</v-btn>

					<v-divider class="my-3"></v-divider>
					<v-btn depressed rounded text @click="logout()" :loading="loggingOut">
						<v-icon>mdi-logout</v-icon> Wyloguj
					</v-btn>
				</div>
			</v-list-item-content>
		</v-card>
	</v-menu>
</template>

<script>
import { mapGetters } from "vuex";
import Avatar from "@/components/Avatar";
import axios from 'axios';
export default {
	name: "UserMenu",
	components: {
		Avatar,
	},
	dat() {
		return {
			loggingOut: false
		}
	},
	computed: {
		...mapGetters({
			user: "auth/user",
		}),
		username() {
			let username = null;
			if(this.user.name != this.user.email) {
				if(this.user.name.length > 18) {
					let arr = this.user.name.split(' ');
					if(arr.length > 1) {
						username = arr[0];
					}
					else {
						if(arr[0].length <= 18) {
							username = arr[0];
						}
					}
				}
			}
			return username;

		},
		logoutUrl() {
		return process.env.VUE_APP_LV_URL + '/logout';
	}
	},
	methods: {
		async logout() {
			this.loggingOut = true;
			await axios.get('/logout')
				.then(() => {
					window.location.href = '/'
				})
				.catch(error => {
					this.$snackbar.error({error: error})
				})

			this.loggingOut = false;
		}
	}

};
</script>

<style lang="scss" scoped>
.user-name {
	font-weight: 500;
	text-align: left;
	.subtitle {
		color: $muted;
		font-size: 12px;
	}
}
</style>
